import React from 'react'
import { Router, Link, browserHistory } from 'react-router'
import { inject, observer } from 'src/core/store'
// @inject('store')
// @observer
//
import config from 'src/core/config'
import Notfound from 'src/core/nomatch'
import layout from 'src/layout'
import oauth from './oauth'
// 切换浏览器访问模式
const history = browserHistory

function errorLoading(cb) {
  return (...arg) => {
    let t = ''
    arg.map((d) => {
      t += `${d}\n`
    })
    console.error(t)
    cb(null, Notfound)
  }
}

function loadRoute(cb) {
  return (module) => cb(null, inject('store')(observer(module.default)))
}

function loadComponent() {
  return function (location, cb) {
    let { module, controller, action } = location.params
    controller = controller || config.route.default.controller
    action = action || config.route.default.action
    if (!module) {
      return history.push(`/${config.route.default.module}/${config.route.default.controller}/${config.route.default.action}`)
    }
    import(`src/pages/${module}/${controller}/${action}.js`).then(loadRoute(cb)).catch(errorLoading(cb))
  }
}
const routes = {
  path: '/',
  component: layout,
  onEnter: oauth,
  indexRoute: {
    getComponent: loadComponent()
  },
  childRoutes: [
    {
      path: ':module/:controller',
      getComponent: loadComponent()
    },
    // 独立子页面
    {
      path: ':module/:controller/:action',
      getComponent: loadComponent()
    },
    { path: '*', component: Notfound }
  ]
}

const RouteComponent = () => (
  <Router key={new Date()} history={history} routes={routes}></Router>
)

export {
  routes,
  history,
  Router,
  Link,
  RouteComponent
}



// WEBPACK FOOTER //
// ./core/router.js